import { useState } from 'react';

const faqs = [
  {
    q: 'Who provides HVAC services near me in North Carolina?',
    a: 'Air-Tek NC provides professional HVAC services across Southern North Carolina, including Fayetteville, Hope Mills, Lumberton, Dunn, and surrounding areas. We offer installation, repair, and maintenance for both residential and commercial systems with fast response times and experienced technicians — available 24/7.',
  },
  {
    q: 'How much does HVAC service cost?',
    a: 'HVAC service costs vary depending on the system type, repair complexity, or installation scope. Air-Tek NC evaluates your system and provides clear, upfront pricing so you understand exactly what is needed without unexpected costs. We also offer 100% financing so you can get serviced immediately.',
  },
  {
    q: 'How long does HVAC service take?',
    a: 'Most HVAC repairs can be completed within a few hours, while installations are typically completed within one day depending on system complexity and scheduling. Air-Tek NC ensures efficient scheduling and professional installation to minimize disruption to your home or business.',
  },
  {
    q: 'Do you offer emergency HVAC repair?',
    a: 'Yes! Air-Tek NC is available 24/7 for emergency HVAC repairs. Whether your AC stops working on a hot summer night or your heat goes out in winter, call us at (919) 348-9399 and we\'ll respond quickly to restore your comfort.',
  },
  {
    q: 'Do you offer financing for HVAC services?',
    a: 'Yes — Air-Tek NC offers 100% financing. Finance with us and get serviced immediately. Contact us to learn more about financing options for your HVAC installation or repair.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="bg-[#f8f9fa] py-24">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-[#00d4ff] text-xs font-bold tracking-widest uppercase">FAQ</span>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#0a1628] mt-3 mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Common Questions
          </h2>
          <p className="text-[#6b7280] text-lg">
            Everything you need to know about HVAC services in Southern North Carolina.
          </p>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden"
              itemScope
              itemType="https://schema.org/Question"
              itemProp="mainEntity"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                aria-expanded={openIdx === idx}
              >
                <span className="text-[#0a1628] font-semibold text-base pr-4" itemProp="name">
                  {item.q}
                </span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#00d4ff]/10 shrink-0">
                  <i className={`text-[#00d4ff] text-base transition-transform duration-200 ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </div>
              </button>
              {openIdx === idx && (
                <div
                  className="px-6 pb-5"
                  itemScope
                  itemType="https://schema.org/Answer"
                  itemProp="acceptedAnswer"
                >
                  <p className="text-[#4b5563] text-base leading-relaxed" itemProp="text">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
